<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M14.1654 9.66797C12.3237 9.66797 10.832 11.1596 10.832 13.0013C10.832 13.6263 11.007 14.218 11.3154 14.718C11.8904 15.6846 12.9487 16.3346 14.1654 16.3346C15.382 16.3346 16.4404 15.6846 17.0154 14.718C17.3237 14.218 17.4987 13.6263 17.4987 13.0013C17.4987 11.1596 16.007 9.66797 14.1654 9.66797ZM15.8904 12.643L14.1154 14.2846C13.9987 14.393 13.8404 14.4513 13.6904 14.4513C13.532 14.4513 13.3737 14.393 13.2487 14.268L12.4237 13.443C12.182 13.2013 12.182 12.8013 12.4237 12.5596C12.6654 12.318 13.0654 12.318 13.307 12.5596L13.707 12.9596L15.0404 11.7263C15.2904 11.493 15.6904 11.5096 15.9237 11.7596C16.157 12.0096 16.1404 12.4013 15.8904 12.643Z"
      fill="currentColor"
    />
    <path
      d="M16.6667 3.45833V3.83333C16.6667 4.29167 16.2917 4.66667 15.8333 4.66667H0.833333C0.375 4.66667 0 4.29167 0 3.83333V3.45C0 1.54167 1.54167 0 3.45 0H13.2083C15.1167 0 16.6667 1.55 16.6667 3.45833Z"
      fill="currentColor"
    />
    <path
      d="M0 6.75182V10.8852C0 12.7935 1.54167 14.3352 3.45 14.3352H8.66667C9.15 14.3352 9.56667 13.9268 9.525 13.4435C9.40833 12.1685 9.81667 10.7852 10.95 9.68516C11.4167 9.22682 11.9917 8.87682 12.6167 8.67682C13.6583 8.34349 14.6667 8.38516 15.5583 8.68516C16.1 8.86849 16.6667 8.47682 16.6667 7.90182V6.74349C16.6667 6.28516 16.2917 5.91016 15.8333 5.91016H0.833333C0.375 5.91849 0 6.29349 0 6.75182ZM5 11.5435H3.33333C2.99167 11.5435 2.70833 11.2602 2.70833 10.9185C2.70833 10.5768 2.99167 10.2935 3.33333 10.2935H5C5.34167 10.2935 5.625 10.5768 5.625 10.9185C5.625 11.2602 5.34167 11.5435 5 11.5435Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'PaymentsIcon',
  inheritAttrs: false,
  props: {
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 17
    }
  }
}
</script>